/**
 * 同一のsliceでstdとadvのアクセスキーを扱うと、タブで２つのコースを開いて、stateを変更した際に、
 * もう一方のキーが消えてしまうことがあるため、sliceを分ける。
 */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import callSerialCetificationApi from '../../apis/callSerialCetificationApi';
import {
  SerialCertificationApiRequestParam,
  SerialCertificationApiResponseParam,
} from '../../types/apis/serialCertificationApi';

type StandardAccessKeyState = {
  // STANDARDのアクセスキー
  standardAccesskey: string;
};

/**
 * 初期state
 */
const initialState: StandardAccessKeyState = {
  standardAccesskey: '',
};

const callStandardSerialCetificationAPI = createAsyncThunk<
  SerialCertificationApiResponseParam,
  SerialCertificationApiRequestParam
>('serial/certification/standard', async (args, { rejectWithValue }) => {
  try {
    const response = await callSerialCetificationApi(args);

    return response;
  } catch (error) {
    return rejectWithValue(error);
  }
});

const standardAccessKeySlice = createSlice({
  name: 'standardAccessKey',
  initialState,
  reducers: {
    resetStandardAccesskey: (state) => ({ ...state, standardAccesskey: '' }),
  },
  extraReducers: (builder) => {
    builder.addCase(
      callStandardSerialCetificationAPI.fulfilled,
      (state, action) => {
        if (action.payload.resultCode !== 'OK') {
          return;
        }
        state.standardAccesskey = action.payload.accesskey;
      },
    );
  },
});

export {
  // Slice
  standardAccessKeySlice,
  // STD用のシリアル取得
  callStandardSerialCetificationAPI,
};
export type { StandardAccessKeyState };
